const SCROLL_THRESHOLD_PX = 200;

export function initHeaderScroll(loco) {
  const header = document.querySelector(".site-header");
  if (!header) return;

  const syncFixedHeaderHeightVar = () => {
    const h = header.offsetHeight;
    if (h > 0) {
      document.documentElement.style.setProperty("--site-fixed-header-height", `${h}px`);
    }
  };

  const readScrollY = () => {
    const lenis = loco?.lenisInstance;
    if (lenis && typeof lenis.scroll === "number") return lenis.scroll;
    return window.scrollY || document.documentElement.scrollTop || 0;
  };

  const update = () => {
    if (document.body.classList.contains("menu-overlay-open")) return;
    const y = readScrollY();
    header.classList.toggle("site-header--scrolled", y > SCROLL_THRESHOLD_PX);
    syncFixedHeaderHeightVar();
  };

  if (typeof loco?.subscribeLenisScroll === "function") {
    loco.subscribeLenisScroll(update);
  } else {
    window.addEventListener("scroll", update, { passive: true });
  }

  syncFixedHeaderHeightVar();
  window.addEventListener("resize", syncFixedHeaderHeightVar, { passive: true });

  update();
  requestAnimationFrame(update);

  // ── Nav-link char entrance animation ─────────────────────────────────────
  const gsap = window.gsap;
  const Splitting = window.Splitting;
  if (gsap && Splitting) {
    const navLinks = [...document.querySelectorAll(".site-header .nav-link[data-split]")];
    if (navLinks.length) {
      navLinks.forEach((link) => Splitting({ target: link, by: "chars" }));
      const allChars = navLinks.flatMap((link) => [...link.querySelectorAll(".char")]);
      gsap.fromTo(
        allChars,
        { yPercent: 110, opacity: 0, rotate: 6, transformOrigin: "50% 100%" },
        { yPercent: 0, opacity: 1, rotate: 0, duration: 0.28, ease: "power3.out", stagger: 0.008, delay: 0.2 },
      );
    }
  }
}
